// extracted by mini-css-extract-plugin
module.exports = {"sy6pq31":"sy6pq31"};